import { createModel } from "@rematch/core";
import { client } from "../shared/apiClient";
import { IApiResponseError } from "../shared/dto/IErrorDto";
import { ISessionMaterial } from "../interfaces/ISessionMaterial";

const sessionMaterial = createModel({
  state: {
    sessionMaterials: [] as ISessionMaterial[],
  },
  reducers: {
    setSessionMaterials: (
      state: any,
      sessionMaterials: ISessionMaterial[]
    ) => ({
      ...state,
      sessionMaterials,
    }),
  },
  effects: (dispatch: any) => ({
    async getSessionMaterials(scheduleId) {
      await client.api.sessionMaterial
        .get(scheduleId)
        .then((resp: any) => {
          let sessionMaterials: ISessionMaterial[] = resp.data;
          this.setSessionMaterials(sessionMaterials);
        })
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },

    async addSessionMaterial(sessionMaterial, state) {
      await client.api.sessionMaterial
        .add(sessionMaterial)
        .then(async (resp: any) => {
          await dispatch.sessionMaterial.getSessionMaterials(
            sessionMaterial.scheduleId
          );
        })
        .catch((resp: any) => {
          console.log(resp);
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },

    async updateSessionMaterial(sessionMaterial, state) {
      await client.api.sessionMaterial
        .update(sessionMaterial)
        .then(async (resp: any) => {})
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },

    async deleteSessionMaterial(sessionMaterialId, state) {
      await client.api.sessionMaterial
        .delete(sessionMaterialId)
        .then(() => {})
        .catch((resp: any) => {
          onErrorRedirect(resp);
          let respError: IApiResponseError = resp.response.data;
          if (respError.error) {
            dispatch.alert.showAlert("error", respError);
          }
        });
    },
  }),
});

export default sessionMaterial;

const onErrorRedirect = (resp: any) => {
  if (!resp.response || resp.response.status === 500) {
    window.location.replace(`${client.api.paths.redirect500}`);
  } else if (resp.response.status === 401 || resp.response.status === 403) {
    window.location.replace(`${client.api.paths.redirect403}`);
  }
};
